import { B_ProjectFormCreateBody } from "@/src-refactor/modules/store/qrtk/services/realestate/values/create-realestate.value";
import { HGetValueFromArray } from "@rf-helper/get-value-from-array";
import HFormatDate from "@rf-helper/format/format-date";
import HCheckArray from "@rf-helper/check-have-value";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { C_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";

interface le {
  buildings: B_ProjectFormCreateBody["buildings"];
  removeUnits: B_ProjectFormCreateBody["removeUnits"];
  removeBuildings: B_ProjectFormCreateBody["removeBuildings"];
}

const prepareBuildingToServer = (form: IPropertyForm): le => {
  if (!HCheckArray(form.building)) {
    return {
      buildings: [],
      removeUnits: form.unitsDeleted || [],
      removeBuildings: form.buildingsDeleted || []
    };
  }
  const globalCurrency =
    HGetValueFromArray(form.global_currency_property, "id") || C_CURRENCY.RD.id;
  const buildings = form.building?.map((building, i) => ({
    id: !building.isNew ? building.id : null,
    description: building.name,
    delivers:
      HFormatDate(building.dateDelivery, "back") ||
      HFormatDate(form.deadline_property, "back"),
    units_quantity: building.unitsQuantity || 0,
    is_captured: building.isCaptured ? 1 : 0,
    units: building.units.map(unit => ({
      id: !unit.isNew ? unit.id : null,
      name: unit.name,
      price: unit.price,
      currency_id: globalCurrency,
      total_comission:
        unit.totalCommission || form.fee_sale_percentage_commission_property || 0,
      guaranteed_comission:
        unit.commissionGuaranteed ||
        form.fee_sale_selling_agent_commission_percentage ||
        0,
      features: [
        ...unit.characteristics_cabinets_property,
        ...unit.characteristics_closets_property,
        ...unit.characteristics_door_property,
        ...unit.characteristics_floors_property,
        ...unit.characteristics_frames_property,
        ...unit.characteristics_roof_form_property,
        ...unit.characteristics_type_house_property,
        ...unit.characteristics_roof_property,
        ...unit.characteristics_windows_property,
        ...unit.features
      ].map(feature => feature?.value || feature?.id),
      bedrooms: unit.bedrooms,
      bathrooms: unit.bathrooms || 0,
      half_bathrooms: unit.halfBathrooms || 0,
      parking_spots: unit.parkingSpots || 0,
      sqm_land: unit.metersLand || 0,
      sqm_construction: unit.metersConstruction || 0,
      floor_level: unit.levelFloor || 0,
      floors_total: unit.totalFloor || 0,
      maintenance_fee: unit.maintenanceFee || 0,
      maintenance_currency_id: HGetValueFromArray(unit.maintenanceCurrency, "id")
    }))
  }));
  return {
    buildings: buildings as unknown as B_ProjectFormCreateBody["buildings"],
    removeUnits: form.unitsDeleted as number[],
    removeBuildings: form.buildingsDeleted as number[]
  };
};

export default prepareBuildingToServer;
